import React from 'react'
import './badge.css';
import { getDangerousHtml } from '../../helpers/components';

const Badge = ({children}) => (
    <span className="badge" dangerouslySetInnerHTML={getDangerousHtml(children)} />
);

export default Badge;



// WEBPACK FOOTER //
// ./src/components/Badge/index.js